export enum DragStates {
  /**
   * Selected state is when the user has clicked on a element
   */
  SELECTED = 'selected',
  /**
   * Drag state is when the user is dragging the element
   */
  DRAG = 'drag',
  /**
   * None state is when the user is not interacting with the element
   */
  NONE = 'none',
  /**
   * Rotate state is when the user is rotating the element
   */
  ROTATE = 'rotate'
}
